import { Injectable, inject } from '@angular/core';
import {  CrudQuery, CrudService } from '@shared/modules/crud/crud.service';
import {  MODELNAME } from './consorcios.config';
import { Complain, SUBCOLLECTION } from './complains.config';
import { Observable } from 'rxjs';
import { orderBy, Timestamp } from '@angular/fire/firestore';
import { Interaction } from './interaction.abstract';



@Injectable({
    providedIn: 'root',
})
export class ComplainsService {
    model = MODELNAME;
    crudService = inject(CrudService);
    subcollection = SUBCOLLECTION;

    getAllByUser(id: string): Observable<Complain[]> {
        const path = this.subcollection;
        this.crudService.setModel(path);
        const query: CrudQuery = {
                field: 'administrationUserId',
                operator: '==',
                value: id,
                orderBy: 'createdAt',
                orderByDirection: 'desc',
            };
            return this.crudService.searchCollectionGroup<Complain>(query);
    }
    
 
    getAllByConsorcio(id: string) {
        this.crudService.setModel(
            this.model + '/' + id + '/' + this.subcollection
        );
        return this.crudService.findAll<any>();
    }

    create(consorcioId: string, data: any) {
        const path = this.model + '/' + consorcioId + '/' + this.subcollection;
        this.crudService.setModel(path);
        return this.crudService.add(data);
    }

    update(consorcioId: string, id: string, data: any) {
        const path =
            this.model +
            '/' +
            consorcioId +
            '/' +
            this.subcollection +
            '/' +
            id;
        this.crudService.setModel(path);
        return this.crudService.update('', data);
    }

   

    getSubObjectById(consorcioId: string, id: string) {
        this.crudService.setModel(
            this.model +
                '/' +
                consorcioId +
                '/' +
                this.subcollection +
                '/' +
                id
        );
        return this.crudService.findFirst<any>('');
    }

    delete(consorcioId: string, id: string) {
        const path =
            this.model + '/' + consorcioId + '/' + this.subcollection + '/' + id;
        this.crudService.setModel(path);
        return this.crudService.delete('');
    }

    async countComplains(consorcioId: string): Promise<number> {
         const path =
            this.model + '/' + consorcioId + '/' + this.subcollection;
        this.crudService.setModel(path);
        const complains = await this.crudService.countCollection();
        return complains;
    }

    
      async countByStatusAndDate(filters:{adminId: string,dateFrom?: any,closedFrom?: any,closedBy?: 'agent' | 'human', status?:string[], onlyUrgent?: boolean,urgent?: boolean}): Promise<number> {
             const path =this.subcollection;
        this.crudService.setModel(path);

        const query: any[] = [
           {field: 'administrationUserId',
             operator: '==',
             value: filters.adminId
            }
        ];

        if(filters.dateFrom){
           const dateFromTs = Timestamp.fromDate(filters.dateFrom);
            query.push({
                field: 'createdAt',
                operator: '>=',
                value: dateFromTs,
            });
        }

        if(filters.closedFrom){
              const closedFromTs =Timestamp.fromDate(filters.closedFrom);
            query.push({
                field: 'closedAt',
                operator: '>=',
                value: closedFromTs,
            });
        }

        if(filters.status){
            query.push({
                field: 'status',
                operator: 'in',
                value: filters.status,
            });
        }
        if(filters.closedBy){
            query.push({
                field: 'closedBy',
                operator: '==',
                value: filters.closedBy,
            });
        }

        if(filters.onlyUrgent){
            query.push({
                field: 'urgent',
                operator: '==',
                value: true,
            });
        }
        if(filters.urgent !== undefined){
            query.push({
                field: 'urgent',
                operator: '==',
                value: filters.urgent,
            });
        }

        
        const total = await this.crudService.findWhereGroupCount(query, [{
            orderBy: 'createdAt',
            orderByDirection: 'desc',
        },
        {
            orderBy: 'status',
            orderByDirection: 'asc',
        },
        {
            orderBy: 'urgent',
            orderByDirection: 'asc',
        },
    ]);
        return total;
    }


    searchByStatusAndUrgent(adminId: string, status:string, urgent: boolean) {
        
        const path =this.subcollection;
        this.crudService.setModel(path);

            const filter:any =[
            {
                field: 'status',
                operator: '==',
                value: status,
            },
            {
                field: 'urgent',
                operator: '==',
                value: urgent,
            } ,
            {field: 'administrationUserId',
             operator: '==',
             value: adminId
            }
        ]
        
        return this.crudService.searchCollectionGroupMany<any>(filter,[{
            orderBy: 'createdAt',
            orderByDirection: 'desc',
        }]);
    }



    filter(adminId: string, search:{status: string,consorcioName: string, dateFrom: Date, dateTo: Date}) {
        
        const path =this.subcollection;
        this.crudService.setModel(path);
            
            const filter:any =[
            {
                field: 'consorcioName',
                operator: '>=',
                value: search.consorcioName,
            },
            {
                field: 'consorcioName',
                operator: '<=',
                value: search.consorcioName + '\uf8ff',
            },
            
            {field: 'administrationUserId',
             operator: '==',
             value: adminId
            }
        ]

               

        if(search.dateFrom){
            filter.push({
                field: 'createdAt',
                operator: '>=',
                value: search.dateFrom,
            })
        }

        if(search.dateTo){
            filter.push({
                field: 'createdAt',
                operator: '<=',
                value: search.dateTo,
            })
        }

        if(search.status){
            filter.push( {
                field: 'status',
                operator: '==',
                value: search.status,
            });
        }

        return this.crudService.searchCollectionGroupMany<any>(filter,[{
            orderBy: 'createdAt',
            orderByDirection: 'desc',
        }]);
    }





       searchMultipleByStatus(adminId: string, status:string[]) {
        
        const path =this.subcollection;
        this.crudService.setModel(path);

            const filter:any =[
            {
                field: 'status',
                operator: 'in',
                value: status,
            },
            {field: 'administrationUserId',
             operator: '==',
             value: adminId
            }
        ]
        
        return this.crudService.searchCollectionGroupMany<any>(filter, [{
            orderBy: 'createdAt',
            orderByDirection: 'desc',
        }]);
    }
    searchMultipleByStatusAndUrgent(adminId: string, status:string[], urgent: boolean) {
          const path =this.subcollection;
        this.crudService.setModel(path);

            const filter:any =[
            {
                field: 'status',
                operator: 'in',
                value: status,
            },
            {
                field: 'urgent',
                operator: '==',
                value: urgent,
            } ,
            {field: 'administrationUserId',
             operator: '==',
             value: adminId
            }
        ]
        
        return this.crudService.searchCollectionGroupMany<any>(filter,[{
            orderBy: 'createdAt',
            orderByDirection: 'desc',
        }]);
    }

     searchMultipleByStatusAndUrgentAndDate(filters:{adminId: string,dateFrom?: any,closedFrom?: any,closedBy?: 'agent' | 'human', status?:string[], onlyUrgent?: boolean,urgent?: boolean}) {
             const path =this.subcollection;
        this.crudService.setModel(path);

        const query: any[] = [
           {field: 'administrationUserId',
             operator: '==',
             value: filters.adminId
            }
        ];

        if(filters.dateFrom){
           const dateFromTs = Timestamp.fromDate(filters.dateFrom);
            query.push({
                field: 'createdAt',
                operator: '>=',
                value: dateFromTs,
            });
        }

        if(filters.closedFrom){
              const closedFromTs =Timestamp.fromDate(filters.closedFrom);
            query.push({
                field: 'closedAt',
                operator: '>=',
                value: closedFromTs,
            });
        }

        if(filters.status){
            query.push({
                field: 'status',
                operator: 'in',
                value: filters.status,
            });
        }

        if(filters.onlyUrgent){
            query.push({
                field: 'urgent',
                operator: '==',
                value: true,
            });
        }
        //urgent: false = solo los que no son urgentes (onlyUrgent: false no filtra: trae todos). Igual que countByStatusAndDate
        if(filters.urgent !== undefined){
            query.push({
                field: 'urgent',
                operator: '==',
                value: filters.urgent,
            });
        }
        if(filters.closedBy){
            query.push({
                field: 'closedBy',
                operator: '==',
                value: filters.closedBy,
            });
        }

        
       return this.crudService.searchCollectionGroupMany<any>(query, [{
                orderBy: 'createdAt',
                orderByDirection: 'desc',
            },
            {
                orderBy: 'status',
                orderByDirection: 'asc',
            },
            {
                orderBy: 'urgent',
                orderByDirection: 'asc',
            },
        ]);
    }
      
}
